"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center">
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground text-sm font-medium uppercase tracking-wider hover:text-primary transition-colors duration-[var(--duration-medium)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer id="footer" className="dark bg-background text-foreground py-12 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {}
          <div className="flex justify-center md:justify-start">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/vicistimtito_footer_logo.png" alt="VycistimTito.cz Logo" className="h-7" />
            </Link>
          </div>

          {}
          <MenuProvider menu_id="61" className="flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex gap-4 justify-center md:justify-end">
            {socialLinks.map((social, i) => <Link key={social.label} to={social.href} newTab data-index={i} className="text-primary hover:text-primary-hover transition-colors duration-[var(--duration-medium)] hover-lift" aria-label={social.label}>
                <social.icon className="size-5" />
              </Link>)}
          </div>
        </div>

        {}
        <Separator className="my-8 bg-primary/20" />

        {}
        <div className="text-center text-muted-foreground text-sm">
          <p>&copy; {new Date().getFullYear()} VycistimTito.cz (Green Electric Systems). Všechna práva vyhrazena.</p>
        </div>
      </div>
    </footer>;
}